import { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";

export const useCategories = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const res = await axiosInstance.get("/category");

                const data = Array.isArray(res.data) ? res.data : [];

                const flatten = (items, parentId = null, level = 0) =>
                    items
                        .filter(item => item.parent_category_id === parentId)
                        .flatMap(item => [
                            { ...item, level },
                            ...flatten(items, item.category_id, level + 1)
                        ]);

                setCategories(flatten(data));
            } catch (err) {
                if (process.env.NODE_ENV === "development") {
                    console.error("category load failed", err);
                }
                setCategories([]);
            }
        };

        loadCategories();
    }, []);

    return categories;
};